<template>
  <div class="card shadow"
       :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            {{title}}
          </h3>
        </div>
        <div class="col text-right">
          <router-link to="/rutinas/create"><base-button type="primary" size="sm"> Crear rutina</base-button></router-link>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table class="table align-items-center table-flush"
                  :class="type === 'dark' ? 'table-dark': ''"
                  :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                  tbody-classes="list"
                  :data="tableData">
        <template slot="columns">
          <th></th>
          <th>rutina</th>
          <th>Fecha de inicio</th>
          <th>Fecha fin</th>
          <th>Completado</th>
        </template>

        <template slot-scope="{row}">
          <td class="text-left">
            <base-dropdown class="dropdown por-arriba"
                           position="left">
              <a slot="title" class="btn btn-sm btn-icon-only text-light" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-ellipsis-v"></i>
              </a>

              <template>
                <router-link :to="{ name: 'Ver Rutina', params: { rutinaId: row.id}}" class="dropdown-item"><span>Ver</span></router-link>
                <router-link :to="{ name: 'Editar Rutina', params: { rutinaId: row.id}}" class="dropdown-item"><span>Editar</span></router-link>
                <base-button block  class="dropdown-item" @click="deleterutina(row.id)">
                  <span>Eliminar</span>
                </base-button> 
              </template>
            </base-dropdown>
          </td>
          <th scope="row">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm"><router-link :to="{ name: 'Ver Rutina', params: { rutinaId: row.id}}"><span>{{row.rutina_name}}</span></router-link></span>
              </div>
            </div>
          </th>
          <td class="budget">
            {{row.fecha_inicio}}
          </td>
          <td>
            <badge class="badge-dot mr-4" :type="row.statusType">
              <i :class="`bg-${row.statusType}`"></i>
              <span class="status">{{row.fecha_fin}}</span>
            </badge>
          </td>

          <td>
            <div class="d-flex align-items-center">
              <span class="completion mr-2">{{row.completion}}%</span>
              <div>
                <base-progress :type="row.statusType"
                               :show-percentage="false"
                               class="pt-0"
                               :value="row.completion"/>
              </div>
            </div>
          </td>

          
        
        </template>

      </base-table>
    </div>

    <div class="card-footer d-flex justify-content-end"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <button class="page-item page-link" :disabled="pagination.validated" @click="siguiente">Mostrar más</button>
      <button class="page-item page-link" :disabled="pagination.validated" @click="mostrarTodos">Mostrar todos</button>
    </div>

    <modal :show.sync="modals.modal1">
        <h6 slot="header" class="modal-title" id="modal-title-default">¿Está seguro que desea eliminar la rutina?</h6>
        <p>Si está seguro confirme la eliminación. Una vez realizado no se podrá recuperar la rutina.</p>
        <template slot="footer">
            <base-button type="success" @click.prevent="deleterutina(row.id)" >Confirmar</base-button>
            <base-button type="link" class="ml-auto" @click="modals.modal1 = false">Cerrar
            </base-button>
        </template>
    </modal>
  </div>
</template>
<script>
import { db } from '../../firebaseDb';
import { auth } from '../../firebaseDb';
  export default {
    name: 'rutinas-table',
    props: {
      type: {
        type: String
      },
      title: String
    },
    data() {
      return {
        user: auth.currentUser,
        tableData: [
          
        ],
        modals: {
          modal1: false
        },
        last: null,
        pagination: {
          default: 1,
          total: 0,
          paginas: 0,
          porPagina: 4,
          validated: false
        }
      }
    },
    created: function() {
      this.creado();
    },
    methods: {
      creado(){
        db.collection('users').doc(this.user.uid).collection('rutinas').orderBy("fecha_fin", "desc").get()
      .then(snapshot => {
          this.pagination.total = snapshot.size;
          this.pagination.paginas = Math.ceil(this.pagination.total / this.pagination.porPagina); 
      });
      db.collection('users').doc(this.user.uid).collection('rutinas')
      .limit(this.pagination.porPagina).orderBy("fecha_fin", "desc")
      .onSnapshot({ includeMetadataChanges: true }, (snapshot) => {
        this.last = snapshot.docs[snapshot.docs.length - 1];
        this.tableData = [];
        snapshot.forEach(doc => {
          let item = doc.data()
          item.id = doc.id
          
          let diaRestante = item.fecha_fin.toDate()
          item.fecha_inicio = item.fecha_inicio.toDate().toLocaleDateString('es-ES')
          item.fecha_fin = item.fecha_fin.toDate().toLocaleDateString('es-ES')
          
          let hoy = Date.now()
          let difference = diaRestante - hoy;          
          let days = Math.ceil(difference / (1000 * 3600 * 24));

          let total_days = diaRestante - doc.data().fecha_inicio.toDate()
          let tdays = Math.ceil(total_days / (1000 * 3600 * 24));

          let complet = (days/tdays)*100

          if(complet > 0){
            item.statusType = 'warning'
            item.completion = 100 - Math.round( complet + Number.EPSILON )
          }else{
            item.completion = 100
            item.statusType = 'success'
          }

          this.tableData.push(item)
        })
      })
      },
      siguiente(){
        db.collection('users').doc(this.user.uid).collection('rutinas').orderBy("fecha_fin", "desc")
          .startAfter(this.last)
          .get()
          .then((snapshot) => {
            this.last = snapshot.docs[snapshot.docs.length - 1];
            snapshot.forEach((doc) => {
              let item = doc.data()
            item.id = doc.id
            
            let diaRestante = item.fecha_fin.toDate()
            item.fecha_inicio = item.fecha_inicio.toDate().toLocaleDateString('es-ES')
            item.fecha_fin = item.fecha_fin.toDate().toLocaleDateString('es-ES')
            
            let hoy = Date.now()
            let difference = diaRestante - hoy;          
            let days = Math.ceil(difference / (1000 * 3600 * 24));

            let total_days = diaRestante - doc.data().fecha_inicio.toDate()
            let tdays = Math.ceil(total_days / (1000 * 3600 * 24));

            let complet = (days/tdays)*100

            if(complet > 0){
              item.statusType = 'warning'
              item.completion = 100 - Math.round( complet + Number.EPSILON )
            }else{
              item.completion = 100
              item.statusType = 'success'
            }

            this.tableData.push(item)
            });
            try {
              db.collection("users").doc(this.user.uid).collection("pesos")
                .limit(this.pagination.porPagina)
                .orderBy("fecha_fin", "desc")
                .startAfter(this.last)
                .get();
            } catch (error) {
              console.error(error);
              this.pagination.validated = true;
            }
          })
          .catch((error) => {
              console.error(error);
          });
      },
      mostrarTodos(){
        db.collection('users').doc(this.user.uid).collection('rutinas').orderBy("fecha_fin", "desc")
          .startAfter(this.last)
          .get()
          .then((snapshot) => {
            this.last = snapshot.docs[snapshot.docs.length - 1];
            snapshot.forEach((doc) => {
              let item = doc.data()
              item.id = doc.id
              
              let diaRestante = item.fecha_fin.toDate()
              item.fecha_inicio = item.fecha_inicio.toDate().toLocaleDateString('es-ES')
              item.fecha_fin = item.fecha_fin.toDate().toLocaleDateString('es-ES')
              
              let hoy = Date.now()
              let difference = diaRestante - hoy;          
              let days = Math.ceil(difference / (1000 * 3600 * 24));

              let total_days = diaRestante - doc.data().fecha_inicio.toDate()
              let tdays = Math.ceil(total_days / (1000 * 3600 * 24));

              let complet = (days/tdays)*100

              if(complet > 0){
                item.statusType = 'warning'
                item.completion = 100 - Math.round( complet + Number.EPSILON )
              }else{
                item.completion = 100
                item.statusType = 'success'
              }

              this.tableData.push(item)
            });
          })
          .catch((error) => {
              console.error(error);
          });
      },
      deleterutina(id){
        if (window.confirm("¿Está seguro de eliminar esta rutina?")) {
          db.collection("users").doc(this.user.uid).collection('rutinas').doc(id).delete().then(() => {
              console.log("Document deleted!");
              this.track();
              this.tableData = [];
              this.creado();
          })
          .catch((error) => {
              console.error(error);
          })
        }
      },
      track() {
        this.$gtag.event("deleted_rutina", {
        'event_category': "rutina",
        'event_label': "rutina_deleted",
        'value': 1
        })
      }, 
    } 
  }
</script>
<style>
.por-arriba{
  position: absolute;  
}
.page-item{
  margin: 2px;
}
</style>
